import type { ReactNode } from "react";

import DrawerDialog from "@/components/shared/DrawerDialog/DrawerDialog";

// Closes only via the cross; the cross hides while the estimate loads
export const SwitchIntervalDialog = ({
  isOpen,
  isEstimating,
  onClose,
  children,
}: {
  isOpen: boolean;
  isEstimating: boolean;
  onClose: () => void;
  children: ReactNode;
}) => (
  <DrawerDialog
    modalState={isOpen}
    handleCloseModal={onClose}
    noCloseButton={isEstimating}
    closeOnEsc={false}
    className="max-h-180.5 w-full max-w-135 bg-white p-0"
    mobileDrawer={true}
    overlayClassName="bg-black/70 backdrop-blur-md"
  >
    {children}
  </DrawerDialog>
);
